module.exports = __webpack_public_path__ + "static/media/cat.f311008d.svg";